








































































































































import { mapGetters } from "vuex";
import { Home, App, General } from "@/utils/constants";
import govLogo from "@/assets/svg/GOV_CE_LOGO.svg";
import govLogoContrast from "@/assets/svg/GOV_CE_LOGO_WHITE.svg";
import FloatingButton from "@/components/FloatingButton";

export default {
  name: "Footer",
  components: {
    FloatingButton
  },
  props: {
    isReduced: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      Home,
      App,
      General,
      seplagFullName: Home.SEPLAG_FULL_NAME,
      seplagAddress: Home.SEPLAG_ADDRESS,
      seplagAddressComplement: Home.SEPLAG_ADDRESS_COMPLEMENT,
      seplagAddressComplementCep: Home.SEPLAG_ADDRESS_COMPLEMENT_CEP,
      seplagCA: Home.SEPLAG_CA,
      seplagAccessbility: Home.SEPLAG_ACCESSIBILITY,
      seplagSchedule: Home.SEPLAG_SCHEDULE,
      seplagSite: Home.SEPLAG_SITE,
      seplagFacebook: Home.SEPLAG_FACEBOOK,
      seplagTwitter: Home.SEPLAG_TWITTER,
      seplagInstagram: Home.SEPLAG_INSTAGRAM,
      govLogo,
      govLogoContrast
    };
  },
  computed: {
    ...mapGetters({ isContrast: "isContrast" }),
    isHome() {
      return this.$router.currentRoute.name === "home";
    }
  },
  methods: {
    goToHelpCenter() {
      window.open(Home.SEPLAG_HELP_CENTER_SITE_LINK, "_blank");
    }
  }
};
